import { render } from "./profileFour.vue?vue&type=template&id=a1d1a24e"
import script from "./profileFour.vue?vue&type=script&lang=js"
export * from "./profileFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__